// extracted by mini-css-extract-plugin
export var animationToLeftSide = "Slider-module--animationToLeftSide--dd4b1";
export var elementsContainer = "Slider-module--elementsContainer--52a42";
export var elementsContainerCopy = "Slider-module--elementsContainerCopy--2e9b7";
export var elementsWrapper = "Slider-module--elementsWrapper--d07dd";
export var infiniteScroll = "Slider-module--infinite-scroll--a5ad5";
export var leftInfiniteScroll = "Slider-module--left-infinite-scroll--7136a";
export var stopAnimation = "Slider-module--stopAnimation--11904";